export default __webpack_public_path__ + "pl.c537e41d.svg";